import styled from '@emotion/styled';
import { CounterIncrementIcon } from '@liveoptics/react-ui';
import React from 'react';
import TextButton from './TextButton';

export interface BackButtonProps {
  onClick: () => void;
}

const Back = styled.div`
  a {
    display: flex;
    align-items: baseline;
  }
  svg {
    padding-bottom: 6px;
    rotate: -90deg;
    height: fit-content;
    width: fit-content;
  }
`;

export const BackButton = (props: BackButtonProps) => {
  return (
    <Back>
      <TextButton onClick={props.onClick}>
        <CounterIncrementIcon></CounterIncrementIcon>
        Back
      </TextButton>
    </Back>
  );
};
